module.exports = __webpack_public_path__ + "media/images/drivers/small/DEFAULT-4141cfae5d89ce9fbb477f0067c0d8ed.jpg";